import React from "react";
// @material-ui/core components
import { useTheme } from "@material-ui/core/styles";
import Avatar from "@material-ui/core/Avatar";
import Box from "@material-ui/core/Box";
import Card from "@material-ui/core/Card";
import CardHeader from "@material-ui/core/CardHeader";
import CardContent from "@material-ui/core/CardContent";
import Grid from "@material-ui/core/Grid";
import LinearProgress from "@material-ui/core/LinearProgress";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import Typography from "@material-ui/core/Typography";

// core components
import boxShadows from "assets/theme/box-shadow.js";

const items = [
  {
    image: require("assets/img/theme/bootstrap.jpg").default,
    name: "Argon Design System",
    color: "warning",
    value: 60,
  },
  {
    image: require("assets/img/theme/angular.jpg").default,
    name: "Angular Now UI Kit PRO",
    color: "success",
    value: 100,
  },
  {
    image: require("assets/img/theme/sketch.jpg").default,
    name: "Black Dashboard",
    color: "error",
    value: 72,
  },
  {
    image: require("assets/img/theme/react.jpg").default,
    name: "Material Dashboard React",
    color: "info",
    value: 90,
  },
];

function CardProgressTrack() {
  const theme = useTheme();
  const sxProgress = {
    infoLinearProgress: {
      backgroundColor: theme.palette.info.main,
    },
    successLinearProgress: {
      backgroundColor: theme.palette.success.main,
    },
    errorLinearProgress: {
      backgroundColor: theme.palette.error.main,
    },
    warningLinearProgress: {
      backgroundColor: theme.palette.warning.main,
    },
  };
  return (
    <>
      <Card
        sx={{
          boxShadow: boxShadows.boxShadow + "!important",
          border: "0!important",
        }}
        elevation={0}
      >
        <CardHeader
          subheader="Progress Track"
          subheaderTypographyProps={{
            component: Box,
            variant: "h3",
            sx: {
              marginBottom: "0!important",
              color: theme.palette.dark.main,
              display: "flex",
            },
          }}
        ></CardHeader>
        <CardContent
          sx={{ paddingTop: "0!important", paddingBottom: "0!important" }}
        >
          <List disablePadding>
            {items.map((prop, key) => {
              return (
                <ListItem
                  key={key}
                  sx={{
                    paddingLeft: 0,
                    paddingRight: 0,
                    "&:not(:last-of-type)": {
                      borderBottom: "1px solid " + theme.palette.gray[200],
                    },
                  }}
                >
                  <Grid container component={Box} sx={{ alignItems: "center" }}>
                    <Grid item xs="auto">
                      <Avatar alt="..." src={prop.image} />
                    </Grid>
                    <Grid
                      item
                      sx={{ flexBasis: 0, flexGrow: 1, maxWidth: "100%" }}
                    >
                      <Typography variant="h5" component="h5">
                        {prop.name}
                      </Typography>
                      <Box sx={{ width: "100%" }}>
                        <LinearProgress
                          variant="determinate"
                          value={prop.value}
                          sx={{
                            height: "3px!important",
                            margin: "0!important",
                            "& .MuiLinearProgress-bar":
                              sxProgress[prop.color + "LinearProgress"],
                          }}
                        />
                      </Box>
                    </Grid>
                  </Grid>
                </ListItem>
              );
            })}
          </List>
        </CardContent>
      </Card>
    </>
  );
}

export default CardProgressTrack;
